import React, { useMemo } from 'react';
import ActivityListItem from './ActivityListItem';
import { groupActivitiesByDate } from './activityDateUtils';

function ActivityGroupedList({ records, onViewDetails }) {
    const groups = useMemo(() => groupActivitiesByDate(records), [records]);

    return (
        <div className="activity-list">
            {groups.map((group) => (
                <section key={group.dateKey} className="activity-date-group">
                    <div className="activity-date-group__header">{group.label}</div>
                    <div className="activity-date-group__items">
                        {group.items.map((item) => (
                            <ActivityListItem
                                key={item.id}
                                item={item}
                                onViewDetails={onViewDetails}
                            />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}

export default ActivityGroupedList;
